"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useRecommendationBusinessSolutionTabs = require("../../../../hooks/recommendation/useRecommendationBusinessSolutionTabs");
var _services = require("../../../../services");
var _MaacBusinessSolutionCard = _interopRequireDefault(require("./MaacBusinessSolutionCard"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const BorderWrapper = _styledComponents.default.div`
  border: 1px solid #bebebe;
  border-radius: 12px;
`;
const TabWrapper = _styledComponents.default.div`
  padding: 20px 24px;
`;
const MaacBusinessSolutionTab = _ref => {
  let {
    businessSolutions,
    selectedBusinessSolution
  } = _ref;
  const {
    onTabSwitch
  } = (0, _useRecommendationBusinessSolutionTabs.useRecommendationBusinessSolutionTabs)();
  return /*#__PURE__*/_react.default.createElement(BorderWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Tabs, {
    tabs: {
      width: 'stretch'
    },
    onTabClick: onTabSwitch,
    externallySetTabId: selectedBusinessSolution.productId
  }, businessSolutions.map(businessSolution => {
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Tab, {
      key: businessSolution.productId,
      text: _services.Services.locale.localeString(`Recommendation.${businessSolution.tier}`),
      id: businessSolution.productId
    }, /*#__PURE__*/_react.default.createElement(TabWrapper, null, /*#__PURE__*/_react.default.createElement(_MaacBusinessSolutionCard.default, {
      businessSolution: businessSolution
    })));
  })));
};
var _default = MaacBusinessSolutionTab;
exports.default = _default;